import { ClientProfileRelationshipType } from '@/types/schema';

/**
 * Individual details for the "Basic info" step of client onboarding.
 */
export interface ClientSetupClientFormShape {
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  /** When set, takes precedence over the legal name everywhere the client is displayed. */
  preferredName: string;
  stateCode: string;
  isDeceased: boolean;
}

export const defaultClientSetupClientFormShape: ClientSetupClientFormShape = {
  firstName: '',
  middleName: '',
  lastName: '',
  suffix: '',
  preferredName: '',
  stateCode: '',
  isDeceased: false,
};

/** 'primary' = clientOne dies first (default), 'secondary' = clientTwo dies first */
export type DefaultDeathOrder = 'primary' | 'secondary';

export interface ClientSetupFormShape {
  primaryRelationshipOwnerId: string;
  subBrandId: string;
  teamIds: string[];
  integrationClientIds: string[];
  clientOne: ClientSetupClientFormShape;
  clientTwo: ClientSetupClientFormShape;
  isProspect: boolean;
  relationshipToBetweenPrimaryClients: ClientProfileRelationshipType | '';
  defaultDeathOrder: DefaultDeathOrder;
}
